export { default as SearchResultModel } from './model'
